import { v4 } from "uuid"

export class LinqChartData {
    _key:string
    
    constructor(public name:string, public value:number, public color?:string, public comparison?:number) {
        this._key = v4()
        this.name = name.length > 20?name.substring(0, 19) + "..":name
    }
}
